'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _reactScroll = require('react-scroll');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _constants = require('./constants');
var _components = require('../../components');

var _PublishNewHomesForm = require('./PublishNewHomesForm.scss');var styles = _interopRequireWildcard(_PublishNewHomesForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

ProjectAdvantages = function (_Component) {_inherits(ProjectAdvantages, _Component);function ProjectAdvantages() {var _temp, _this, _ret;_classCallCheck(this, ProjectAdvantages);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    renderAdvantage = function (advantage, index, fields) {var _this$props =





      _this.props,translate = _this$props.translate,locale = _this$props.locale,formFields = _this$props.fields,isForeign = _this$props.isForeign;

      var handleRemove = function handleRemove() {return fields.remove(index);};
      return (
        _react2.default.createElement('div', { key: advantage },
          _react2.default.createElement('div', { className: styles.advantageWrapper },
            _react2.default.createElement('p', null, translate('addNewProject', 'advantage') + ' ' + (index + 1)),
            _react2.default.createElement('button', {
                type: 'button',
                onClick: handleRemove,
                className: styles.deleteButton },

              translate('addNewProject', 'delete'))),


          _react2.default.createElement('p', { className: styles.titleName }, translate('addNewProject', 'title')),
          _react2.default.createElement(_components.OMTextFieldWithOptionsLang, {
            translate: translate,
            classNameTabs: 'project-form',
            className: 'form-control',
            name: advantage + '.title',
            locale: locale,
            fields: (0, _get2.default)(formFields, advantage + '.title'),
            isInput: true,
            maxLength: '80',
            isOptionalLangsDisabled: !(0, _get2.default)(formFields, advantage + '.title.' + (isForeign ? 'en' : 'he')),
            isForeign: isForeign }),

          _react2.default.createElement('p', { className: styles.titleName }, translate('addNewProject', 'description')),
          _react2.default.createElement(_components.OMTextFieldWithOptionsLang, {
            translate: translate,
            name: advantage + '.description',
            locale: locale,
            fields: (0, _get2.default)(formFields, advantage + '.description'),
            classNameTabs: 'project-form',
            className: 'form-control',
            isOptionalLangsDisabled: !(0, _get2.default)(formFields, advantage + '.description.' + (isForeign ? 'en' : 'he')),
            isForeign: isForeign,
            maxLength: '250' })));



    }, _this.

    renderFields = function (_ref) {var fields = _ref.fields,meta = _ref.meta;var
      translate = _this.props.translate;
      var canAddAdvantage = fields.length < _constants.MAX_ADVANTAGES;

      var handleAddAdvantage = function handleAddAdvantage() {return fields.push({});};

      return (
        _react2.default.createElement('div', { className: styles.commodities },
          _react2.default.createElement('span', { className: styles.label },
            translate('addNewProject', 'advantages')),

          _react2.default.createElement('div', { className: styles.inputs },
            fields.map(function (advantages, index) {return _this.renderAdvantage(advantages, index, fields, meta);}),
            canAddAdvantage && _react2.default.createElement('button', {
                className: styles.addObject,
                onClick: handleAddAdvantage,
                type: 'button',
                disabled: !canAddAdvantage },

              _react2.default.createElement('span', { className: styles.plus }, '+'),
              translate('addNewProject', 'addAdvantage')))));




    }, _temp), _possibleConstructorReturn(_this, _ret);}ProjectAdvantages.prototype.

  render = function render() {
    return (
      _react2.default.createElement(_reactScroll.Element, { name: this.props.name, className: styles.commoditiesWrapper },
        _react2.default.createElement(_reduxForm.FieldArray, {
          name: this.props.name,
          component: this.renderFields })));



  };return ProjectAdvantages;}(_react.Component);exports.default = ProjectAdvantages;


ProjectAdvantages.propTypes = {
  push: _propTypes2.default.func.isRequired,
  remove: _propTypes2.default.func.isRequired,
  name: _propTypes2.default.string.isRequired,
  locale: _propTypes2.default.string.isRequired,
  isForeign: _propTypes2.default.bool.isRequired,
  translate: _propTypes2.default.func.isRequired,
  fields: _propTypes2.default.object,
  changeValue: _propTypes2.default.func.isRequired,
  replaceAt: _propTypes2.default.func.isRequired,
  isRtl: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishNewHomesForm/ProjectAdvantages.js
// module id = 2997
// module chunks = 0